module.exports = __webpack_public_path__ + "img/bg.8541714a.png";